'use strict';

import { sendGtmRouteChangeEvent } from '../util/gtm';
import { updatePageTitle } from '../util/spa';

const stepSelector = '.js-bscan-step.active';
const nameAttribute = 'data-bscan-step-name';
const indexAttribute = 'data-bscan-step-index';

/**
 * @public initStartPage
 */
function initStartPage() {
    const startStep = document.querySelector(stepSelector);
    const stepName = startStep && startStep.getAttribute(nameAttribute);

    if (stepName) {
        sendGtmRouteChangeEvent.call(this, stepName);
    }

    if (startStep.getAttribute(indexAttribute) >= 0) {
        updatePageTitle.call(this, stepName);
    }
}

export { initStartPage };
